import { CLASSROOM_TYPE } from '../../../modules/classroom';
import type { TempClassroom } from '../add-classroom-modal';

type Props = {
  state: TempClassroom;
  isSecondarySelected: boolean;
  classroomType?: string;
};

type Return = {
  isValid: boolean;
};

function useClassroomValidation({
  state,
  isSecondarySelected,
  classroomType,
}: Props): Return {
  const isNameValid = !!state.name?.trim();
  const isCourseIdValid =
    classroomType === CLASSROOM_TYPE.JOURNEYS || !!state.courseId;
  const isDigitalPracticeValid =
    !isSecondarySelected || !!state.digitalPracticeFirstDayOfWeek;

  const isValid = isNameValid && isCourseIdValid && isDigitalPracticeValid;

  return {
    isValid,
  };
}

export { useClassroomValidation };
